import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import log from "./log.png";
import "./header.css";

const Header = () => {
  useEffect(() => {
    const overlay = document.querySelector(".mobile-overlay");
    const openBtn = document.querySelector(".menu-btn");
    const closeBtn = document.querySelector(".close-btn");

    if (!overlay || !openBtn || !closeBtn) return;

    const openMenu = (e) => {
      e.stopPropagation();
      overlay.classList.add("open");
      document.body.classList.add("menu-open");
    };

    const closeMenu = (e) => {
      e.stopPropagation();
      overlay.classList.remove("open");
      document.body.classList.remove("menu-open");
    };

    const closeOnOverlayClick = (e) => {
      // Only close when clicking the dark overlay (not inside drawer)
      if (e.target.classList.contains("mobile-overlay")) {
        closeMenu(e);
      }
    };

    openBtn.addEventListener("click", openMenu);
    closeBtn.addEventListener("click", closeMenu);
    overlay.addEventListener("click", closeOnOverlayClick);

    return () => {
      openBtn.removeEventListener("click", openMenu);
      closeBtn.removeEventListener("click", closeMenu);
      overlay.removeEventListener("click", closeOnOverlayClick);
    };
  }, []);

  return (
    <nav>
      <div className="navbar">
        {/* ✅ Hamburger button (always visible on mobile) */}
        <button className="menu-btn" aria-label="Open menu" type="button">
          <span className="bar" />
          <span className="bar" />
          <span className="bar" />
        </button>

        {/* Logo */}
        <div className="logo">
          <NavLink to="/" className="logo-link">
            <img className="logo-img" src={log} alt="Xceed Office" />
            <span className="logo-text"></span>
          </NavLink>
        </div>

        {/* Desktop links */}
        <div className="desktop-nav">
          <ul className="desktop-links">
            <li><NavLink  to="/about">About Us</NavLink></li>
              <li><NavLink to="/location">Location</NavLink></li>
            <li><NavLink to="/pricing">Pricing</NavLink></li>
            <li><NavLink style={{display:"none"}} to="/space">Space</NavLink></li>
            <li><NavLink style={{display:"none"}} to="/membership">Membership</NavLink></li>
            <li><NavLink style={{display:"none"}} to="/faq">FAQ</NavLink></li>
            <li><NavLink style={{display:"none"}} to="/contact">Contact</NavLink></li>
          
          </ul>
        </div>

        {/* ✅ Mobile overlay + LEFT drawer */}
        <div  className="mobile-overlay">
          <div className="mobile-drawer" role="dialog" aria-modal="true">
            <div className="drawer-top">
              <div className="drawer-brand">
                <img style={{width:"80%"}} src={log} alt="Xceed Office" />
                <div>
                  <div style={{display:"none"}} className="drawer-title">Xceed Office</div>
                  <div style={{display:"none"}} className="drawer-sub">Executive Workspace</div>
                </div>
              </div>

              <button className="close-btn" aria-label="Close menu" type="button">
                ×
              </button>
            </div>

            <ul  className="drawer-links">
              <li><NavLink to="/about">About Us</NavLink></li>
              <li ><NavLink to="/location">Location</NavLink></li>
             <li><NavLink to="/pricing">Pricing</NavLink></li>
              <li style={{display:"none"}}><NavLink to="/space">Space</NavLink></li>
              <li><NavLink to="/contact">Contact</NavLink></li>
              <li style={{display:"none"}}><NavLink to="/membership">Membership</NavLink></li>
              <li style={{display:"none"}}><NavLink to="/faq">FAQ</NavLink></li>
              
            </ul>

            <div className="drawer-cta" style={{}}>
              <ul style={{marginTop:"-10%"}}>
            <li className="drawer-btn"  style={{marginTop:"3%",textAlign:"center"}}><a href="/about" style={{color:"black",textAlign:"center"}} to="/about">About Us</a></li>
           <li className="drawer-btn"  style={{marginTop:"3%",textAlign:"center"}}><a href="/location" style={{color:"black",textAlign:"center"}} to="/contact">Location</a></li>
              <li  className="drawer-btn" style={{marginTop:"3%",textAlign:"center"}}><a href="/pricing" style={{color:"black",textAlign:"center"}}>Pricing</a></li>
            <li  className="drawer-btn" style={{marginTop:"3%",textAlign:"center",display:"none"}}><a href="/space" style={{color:"black",textAlign:"center"}}>Space</a></li>
            <li className="drawer-btn"  style={{marginTop:"3%",textAlign:"center",display:"none"}}><a href="/membership" style={{color:"black",textAlign:"center"}} to="/membership">Membership</a></li>
            <li  className="drawer-btn" style={{marginTop:"3%",textAlign:"center",display:"none"}}><a href="/faq" style={{color:"black",textAlign:"center"}} to="/faq">FAQ</a></li>
            <li className="drawer-btn"  style={{marginTop:"3%",textAlign:"center"}}><a href="/contact" style={{color:"black",textAlign:"center"}} to="/contact">Contact</a></li>
          </ul>
              <button style={{display:"none"}} className="drawer-btn" type="button">Schedule a Tour</button>
              <a style={{display:"none"}} className="drawer-phone" href="tel:+12817176060">
                Call: (281) 717-6060
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;